import * as React from 'react';
import {render} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import BaseLayout from './BaseLayout';
import Promise from 'promise-polyfill';
require('./images/favicon.ico'); // Tell webpack to load favicon.ico

import './styles/app.scss';

 function run() {
  if (!window.Promise) {
    window.Promise = Promise;
  }

  render(
    <BrowserRouter>
      <BaseLayout />
    </BrowserRouter>, document.getElementById('app')
  );
}

if (!window.Intl) {

  // Webpack parses the inside of require.ensure at build time to know that intl
  // should be bundled separately. You could get the same effect by passing
  // ['intl'] as the first argument.

    // Ensure only makes sure the module has been downloaded and parsed.
    // Now we actually need to run it to install the polyfill.
    require('intl');
    // Carry on
    run();

} else {

  // Polyfill wasn't needed, carry on
  run();
}





/** WEBPACK FOOTER **
 ** ./src/index.js
 **/